export default __webpack_public_path__ + "static/media/fleshofthewight.e5e20fa0.png";